import { useLang } from '@/i18n';
import EfNavProduct, { EfNavProductItemProps } from '@elem/ui/ef-nav-product';
import { useRouter } from 'next/router';
import { useProductDispatch } from '../../ProductProvider';
import gtm from '@/utils/gtm';

export default function NavProduct() {
    const { t } = useLang('theProduct.NavProduct');
    const dispatch = useProductDispatch();
    const { locale } = useRouter();
    const list: EfNavProductItemProps[] = [
        {
            type: 'Product',
            title: t('Product'),
        },
        {
            type: 'Support',
            title: t('Support'),
        },
        {
            type: 'Specs',
            title: t('Specs'),
        },
    ];

    const buyConfig = {
        title: t('buy_now'),
        href:
            locale === 'mx'
                ? 'https://mx.ecoflow.com/products/125w-bifacial-modular-solar-panel'
                : locale === 'br'
                ? 'https://br.ecoflow.com/checkouts/cn/Z2NwLXVzLXdlc3QxOjAxSlBQVk5TMDJLQzhGSzhCMzUwWTVBN1lG'
                : 'https://ecoflow-tech.myshopify.com/cart/41838060404809:1?channel=buy_button',
    };
    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.type,
        });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);
    };

    const handleBuyCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: 'EcoFlow 125W Bifacial Solar Panel',
            position: 'New Release',
        });
    };

    return (
        <EfNavProduct
            selectType="Product"
            type="select"
            theme="white"
            name={t('name')}
            list={list}
            callback={itemCallback}
            locale={locale}
            buyItem={buyConfig}
            buyCallback={handleBuyCallback}
        ></EfNavProduct>
    );
}
